export default {
    en: {
        home: {
            welcome: "Hello",
            title: "",
            subTitle: "",
            topics: "",
            email: "",
            emailButton: ""
        }
    },
    de: {
        topBar: {
            title: "Häufige Fragen"
        },
        home: {
            welcome: "Hallo",
            title: "du hast eine Frage und brauchst eine schnelle Antwort?",
            topics: "Hier findest du kompakte Antworten auf die häufigsten Fragen zu den folgenden Themen:",
            email: "Solltest du nicht die richtige Antwort auf deine Frage finden, kontaktiere uns bitte hier:",
            emailButton: "E-Mail Kontakt"
        }
    }
}
